<template>
  <right-menu-item
    :href="url"
    mode="ajax"
    :class="{ 'muted': !show }"
    :text="$t('Edit share')"
    icon="pen"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  computed: {
    url() {
      if (this.bcSelectedStore.list.length < 1) return '#'
      return this.$presenterInfo.url.split('?')[0] + '?do=setForm&sid=' + this.bcSelectedStore.list[0].id
    },
    show() {
      return this.bcSelectedStore.list.length == 1 && this.bcSelectedStore.list[0].type == 'link'
    },
    ...mapStores(useBcSelectedStore)
  },
}
</script>

<style lang="scss" scoped></style>
